module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumbs', {
    attrs: {
      "crumbs": _vm.crumbs
    }
  }), _vm._v(" "), _c('form-builder', {
    attrs: {
      "id": _vm.formId
    },
    on: {
      "form-loaded": _vm.formLoaded,
      "duplicate-form": _vm.duplicateForm,
      "remove-form": _vm.removeForm
    }
  }), _vm._v(" "), (_vm.showDuplicateFormModal) ? _c('duplicate-form-modal', {
    attrs: {
      "duplicate-form-id": _vm.duplicateFormId
    },
    on: {
      "hide": function($event) {
        _vm.showDuplicateFormModal = false
      },
      "duplicate-success": _vm.formDuplicated
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showRemoveFormModal) ? _c('remove-form-modal', {
    attrs: {
      "form-id": _vm.formId
    },
    on: {
      "form-removed": _vm.formRemoved,
      "display": function($event) {
        _vm.showRemoveFormModal = $event
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14bf8122","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/FormBuilderEditor.vue
// module id = 1562
// module chunks = 1